<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MDkWDv/tc-custom/9781328663085.jpg?1701639301390" alt="This image is the cover for the book Best American Food Writing 2018, The Best American Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best American Food Writing 2018, The Best American Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Selected by Ruth Reichl, “punchy and vibrant” essays on food, its place on our tables, in our lives, and in our world (<i>Publishers Weekly</i>).</b><br/>  <br/> The twenty-eight pieces in this volume are about food, yet touch on every pillar of society: from the sense memories that connect a family, to the scientific tinkering that gives us new snacks to share, to the intersections of culinary culture with some of our most significant political issues. Included among other essays are: “Revenge of the Lunch Lady” by Jane Black, food writer for the <i>Washington Post</i>, <i>New York Times</i>, and <i>Wall Street Journal</i>“How Driscoll’s Reinvented the Strawberry” by Dana Goodyear, author of <i>Anything that Moves</i>“Who Owns Uncle Ben?” by Shane Mitchell, James Beard Award winner and <i>Saveur </i>contributing editor“Is Dinner for Two Worth $1,000?” by Jonathan Gold, Pulitzer Prize-winning <i>Los Angeles Times</i> restaurant critic  <br/> At times a celebration, at times a critique, at times a wondrous reverie, <i>The Best American Food Writing 2018</i> is brimming with delights both circumspect and sensuous. Dig in!<br/>  <br/> “For pure food writing fun, it’s hard to beat Baxter Holmes’s ‘The NBA’s Secret Sandwich Addiction,’ which will have readers first laughing incredulously and then hungrily craving a PB&amp;J on plain white bread. Thoughtful and educational, enticing and entertaining, this collection has something for everyone.”—<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Reichl
      </h2>
      
      <p class="authorDescription body article">SILVIA KILLINGSWORTH is the digital editor of Bloomberg Businessweek and a former editor of The Awl and The Hairpin. Prior to that she was the managing editor of The New Yorker, and wrote regularly for their magazine and website. She lives in Westchester County, New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a1e78d6c